namespace Portico.Services {

    import Inject = Portico.Decorators.Inject;
    import Service = Portico.Decorators.Service;

    export interface IToastrService {
        add(type: string, title: string, content: string, options: any);
        removeLast();
        clearAll();
    }

    @Service('app', 'toastrService')
    @Inject('$rootScope')
    export class ToastrService implements IToastrService {
        list: Array<JQuery<HTMLElement>>;
        last: JQuery<HTMLElement>;
        constructor() {
            this.list = [];
            this.last = null;
        }

        add(type: string, title: string, content: string, options: any) {
            if (options) {
                for (var option in options) {
                    toastr.options[option] = options[option];
                }
            }
            let toast: JQuery<HTMLElement> = toastr[type](content, title);
            this.list.push(toast);                        
            this.last = toast;
        }

        removeLast() {
            if(this.list){
                toastr.clear(this.last);
            }
        }

        clearAll() {
            toastr.clear();
        }        

    }
}